// # Help Settings Tab Component
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './help_settings.css';

function HelpSettings({ isDarkMode }) {
  const [activeSection, setActiveSection] = useState('faq');

  // # FAQ data
  const faqs = [
    {
      question: 'How do I access the study materials?',
      answer: 'Once subscribed, you can access all study materials through your dashboard. Navigate to either Step 1 or Step 2 Library sections to find comprehensive study resources.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept major credit cards (Visa, MasterCard, American Express) and PayPal. More payment options will be available soon.'
    },
    {
      question: 'Can I cancel my subscription?',
      answer: 'Yes, you can cancel your subscription at any time through the Subscription Settings. Note that refunds are handled according to our refund policy.'
    },
    {
      question: 'How do I contact my mentor?',
      answer: 'Mentorship communication is handled through our dedicated mentorship platform. Access it via the Mentorship section in your dashboard.'
    },
    {
      question: 'What is included in the subscription?',
      answer: 'Subscriptions include access to comprehensive study materials, practice questions, video lectures, progress tracking, and optional mentorship services.'
    }
  ];

  // # Support channels
  const supportChannels = [
    {
      title: 'Email Support',
      description: 'Get help via email within 24 hours',
      contact: 'support@wearetempu.com',
      icon: 'fas fa-envelope'
    },
    {
      title: 'Social Media',
      description: 'Follow us for updates and support',
      channels: [
        { name: 'Twitter', url: 'https://x.com/We_Are_TEMPU?t=hDMPUGfWyB8RiwiN2eaeWg&s=09', icon: 'fab fa-twitter' },
        { name: 'Facebook', url: 'https://www.facebook.com/share/1VMB4G1KWM/', icon: 'fab fa-facebook' }
      ]
    }
  ];

  return (
    <div className="hlp_st_section">
      <div className="hlp_st_header">
        <h2>Help & Support</h2>
      </div>

      {/* # Navigation Tabs */}
      <div className="hlp_st_help-navigation">
        <button 
          className={`hlp_st_help-nav-btn ${activeSection === 'faq' ? 'active' : ''}`}
          onClick={() => setActiveSection('faq')}
        >
          <i className="fas fa-question-circle"></i>
          FAQs
        </button>
        <button 
          className={`hlp_st_help-nav-btn ${activeSection === 'support' ? 'active' : ''}`}
          onClick={() => setActiveSection('support')}
        >
          <i className="fas fa-headset"></i>
          Support
        </button>
        <button 
          className={`hlp_st_help-nav-btn ${activeSection === 'docs' ? 'active' : ''}`}
          onClick={() => setActiveSection('docs')}
        >
          <i className="fas fa-book"></i>
          Documentation
        </button>
      </div>

      {/* # Content Sections */}
      <div className="hlp_st_help-content">
        {/* # FAQ Section */}
        {activeSection === 'faq' && (
          <div className="hlp_st_faq-section">
            <div className="hlp_st_faq-list">
              {faqs.map((faq, index) => (
                <div key={index} className="hlp_st_faq-item">
                  <h3>{faq.question}</h3>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* # Support Section */}
        {activeSection === 'support' && (
          <div className="hlp_st_support-section">
            {supportChannels.map((channel, index) => (
              <div key={index} className="hlp_st_support-channel">
                <div className="hlp_st_channel-header">
                  <i className={channel.icon}></i>
                  <h3>{channel.title}</h3>
                </div>
                <p>{channel.description}</p>
                {channel.contact && (
                  <a href={`mailto:${channel.contact}`} className="hlp_st_contact-link">
                    {channel.contact}
                  </a>
                )}
                {channel.channels && (
                  <div className="hlp_st_social-links">
                    {channel.channels.map((social, idx) => (
                      <a 
                        key={idx}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hlp_st_social-link"
                      >
                        <i className={social.icon}></i>
                        {social.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* # Documentation Section */}
        {activeSection === 'docs' && (
          <div className="hlp_st_documentation-section">
            <div className="hlp_st_coming-soon-docs">
              <i className="fas fa-tools"></i>
              <h3>Documentation Coming Soon</h3>
              <p>We're currently working on comprehensive documentation for our platform.</p>
              <p>In the meantime, please refer to the FAQs or contact our support team.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

HelpSettings.propTypes = {
  isDarkMode: PropTypes.bool
};

HelpSettings.defaultProps = {
  isDarkMode: false
};

export default HelpSettings; 